import React, { useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { isAndroid, isIOS, isWindows, osName } from "react-device-detect";
import {
  buildAppStoreUrl,
  buildEnrollmentAppUrl,
  buildPlayStoreUrl,
  buildPracticeTokenAppUrl,
  copyIosLandingUrlToClipboard,
} from "../../utils/helpers/enrollmentToken";

const DownloadBiosynciqApp = () => {
  const [searchParams] = useSearchParams();
  const enrollmentToken = searchParams.get("enrollment_token");
  const token = searchParams.get("token");

  useEffect(() => {
    const appUrl = enrollmentToken
      ? buildEnrollmentAppUrl(enrollmentToken)
      : token
        ? buildPracticeTokenAppUrl(token)
        : null;

    const storeUrl =
      isAndroid || isWindows || osName === "Linux"
        ? buildPlayStoreUrl({ enrollmentToken, token })
        : buildAppStoreUrl();

    const goToAppOrStore = () => {
      if (isIOS) {
        window.location.href = storeUrl;
        return;
      }

      if (appUrl) {
        window.location.href = appUrl;
        return;
      }

      window.location.href = storeUrl;
    };

    if (isIOS && (enrollmentToken || token)) {
      copyIosLandingUrlToClipboard().finally(goToAppOrStore);
      return;
    }

    goToAppOrStore();
  }, [enrollmentToken, token]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          fontWeight={600}
          color="text.secondary"
        >
          Loading ...
        </Typography>
      </Box>
    </Container>
  );
};

export default DownloadBiosynciqApp;
